import React from 'react'
import { Box, Button } from '@ui'
import { useEnvironment } from 'hooks/useEnvironment'
import { create } from 'zustand'

export const oneYearInSeconds = 60 * 60 * 24 * 365

export const oneMonthInSeconds = 60 * 60 * 24 * 30

export const oneWeekInSeconds = 60 * 60 * 24 * 7

const durationOptions = [
    { label: '30 sec', value: 30 },
    { label: '5 min', value: 60 * 5 },
    { label: '1 hr', value: 60 * 60 },
    { label: '1 day', value: 60 * 60 * 24 },
    { label: '2 days', value: 60 * 60 * 24 * 2 },
    { label: '3 days', value: 60 * 60 * 24 * 3 },
    { label: '1 week', value: oneWeekInSeconds },
    { label: '1 month', value: oneMonthInSeconds },
    { label: '1 year', value: oneYearInSeconds },
]

export const durationStore = create<{
    duration: number | undefined
    setDuration: (duration: number | undefined) => void
}>((set) => ({
    duration: undefined,
    setDuration: (duration) => set({ duration }),
}))

export function DurationSwitcher() {
    const duration = durationStore((state) => state.duration)
    const setDuration = durationStore((state) => state.setDuration)
    return (
        <Box horizontal position="absolute" top="lg" right="x4" gap="sm" zIndex="above">
            <Box horizontal gap="xs">
                <Button
                    tone={duration === undefined ? 'cta1' : 'level2'}
                    size="button_xs"
                    onClick={() => setDuration(undefined)}
                >
                    Not set
                </Button>

                {durationOptions.map((option) => (
                    <Button
                        tone={duration === option.value ? 'cta1' : 'level2'}
                        key={option.value}
                        size="button_xs"
                        onClick={() => setDuration(option.value)}
                    >
                        {option.label}
                    </Button>
                ))}
            </Box>
        </Box>
    )
}

export function useEnableOnTestEnvs() {
    const environment = useEnvironment()
    const name = environment.name
    return name === 'local_dev' || name === 'beta'
}
